import app from "../_app";

const productPopup = document.querySelector('.js-product-popup');

export const openProductPopupHandler = () => {
    if(productPopup) {
        app.lockBody();

        productPopup.setAttribute('data-open', '');
    }
};

if(productPopup) {
    const closeTriggers = [...productPopup.querySelectorAll('.js-product-popup-close')];

    const closeProductPopupHandler = () => {
        productPopup.removeAttribute('data-open');

        app.unlockBody();
    };

    closeTriggers.map(closeTrigger => closeTrigger.addEventListener('click', closeProductPopupHandler));
}
